import { Box, Button, Input, Text } from 'wikr-core-components';
import React, { useEffect, useState } from 'react';

import Logo from 'components/Logo';

import styles from './loginContainer.module.css';

function LoginContainer({
    onSubmit,
    setIsForgetPasswordForm,
    isLoading,
    isForgotPassword,
}: {
    isForgotPassword: boolean;
    setIsForgetPasswordForm: () => void;
    onSubmit: ({ email, password, onFail }: { email: string; password: string; onFail: () => void }) => void;
    isLoading: boolean;
}) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState<Record<any, string>>({});

    useEffect(() => {
        setErrors({});
    }, [isForgotPassword]);

    const submitHandler = async () => {
        setErrors({});
        if (email.trim() === '') {
            setErrors((prevState) => ({ ...prevState, email: 'Email cannot be empty' }));
        }
        if (password.trim() === '') {
            setErrors((prevState) => ({ ...prevState, password: 'Passwrod cannot be empty' }));
        }

        await onSubmit({
            email,
            password: password.toString(),
            onFail: () =>
                setErrors({
                    email: isForgotPassword ? 'Something went wrong, please try again' : 'email or password is invalid',
                    password: 'email or password is invalid.',
                }),
        });
    };

    const switchModesHandler = () => {
        setIsForgetPasswordForm();
        setErrors({});
    };

    const getIsDisabled = () => {
        if (isForgotPassword) {
            if (!email.trim().length) return true;
        } else {
            if (!password.trim().length || !email.trim().length) return true;
        }
    };

    return (
        <Box className={styles.container}>
            <Box className={styles.form}>
                <Logo />
                {/* @ts-ignore*/}
                <Input
                    label="email"
                    placeholder="Enter email"
                    value={email}
                    type="email"
                    onChange={(e) => setEmail(e.target.value)}
                    name="email"
                    errorStatus={!!errors?.email}
                    errorMessage={errors?.email}
                />
                {!isForgotPassword && (
                    /* @ts-ignore*/
                    <Input
                        placeholder="Enter password"
                        label="password"
                        value={password}
                        type="password"
                        onChange={(e) => setPassword(e.target.value)}
                        name="password"
                        errorStatus={!!errors?.password}
                        errorMessage={errors?.password}
                    />
                )}
                <Button
                    mb={12}
                    text={isForgotPassword ? 'Reset password' : 'Login'}
                    isLoading={isLoading}
                    onClick={submitHandler}
                    disabled={getIsDisabled() || isLoading}
                />
                <button disabled={isLoading} onClick={switchModesHandler} className={styles.forgotPassword}>
                    <Text center color="decorative-a">
                        {isForgotPassword ? 'Back to login' : 'Forgot password?'}
                    </Text>
                </button>
            </Box>
        </Box>
    );
}

export default LoginContainer;
